(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesdiaDialogController', VentamesdiaDialogController);

    VentamesdiaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ventamesdia'];

    function VentamesdiaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ventamesdia) {
        var vm = this;

        vm.ventamesdia = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ventamesdia.id !== null) {
                Ventamesdia.update(vm.ventamesdia, onSaveSuccess, onSaveError);
            } else {
                Ventamesdia.save(vm.ventamesdia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ventamesdiaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
